<template>
  <Navbar />
  <Header v-bind:title="title" />

  <section class="proj-section">
    <TabWrapper>
      <Tab title="重點成果展示">
        <h2 class="proj-tab-title">重點成果展示</h2>
        <div class="proj-rsch-list" v-if="highlightProjs.length">
          <ul >
            <template v-for="(article, index) in highlightProjs" :key="article.id">
              <template v-if="index >= (paginate.num-1)*paginate.size && index < paginate.num*paginate.size" >
                <li class="proj-rsch-item">
                    <a :href="article.pdflink" target="_blank">
                      <div class="rsch-img">
                        <img :src="formattedImgUrl(article.content)" />
                      </div>

                      <h3>{{ article.title }}</h3>
                      <p class="info">
                        <font-awesome-icon :icon="['far', 'clock']" />
                        {{ formattedTimestamp(article.timestamp) }}
                      </p>
                      <p class="info">
                        <font-awesome-icon :icon="['fas', 'list-ul']" />
                        {{ formattedCategory(article.category) }}
                      </p>
                    </a>
                </li>
              </template>
            </template>
          </ul>

          <Paginate :length="highlightProjs.length" :size="paginate.size" :num="paginate.num" @update="pageUpdate" />

        </div>

        <div v-else>
          <Loader />
        </div>
      </Tab>

      <Tab title="歷年分析列表">
        <h2 class="proj-tab-title">歷年分析列表</h2>

        <div class="filter-div">
          <font-awesome-icon :icon="['fas', 'filter']" />
          執行年度：
          <select class="select" v-model="allProjs.selectYear">
            <option :value="year" v-for="year in allProjs.yearArr" :key="year">{{ year }}</option>
          </select>
          學年度
        </div>

        <div class="search-div">
          <font-awesome-icon :icon="['fas', 'magnifying-glass']" />
          <input type="text" class="input-search" placeholder="請輸入要搜尋的單位" v-model="allProjs.searchWords"/>
        </div>
        
        <table class="table table-hover rwd-table">
          <thead>
            <tr>
              <th class="th-title">議題</th>
              <th>相關單位</th>
            </tr>
          </thead>

          <tbody v-if="allProjs.data.length">
            <template v-for="item in filterSearch" :key="item.id">
              <tr v-if="item.year == allProjs.selectYear">
                <td data-th="議題" class="title" v-if="item.url">
                  <a v-bind:href="item.url" target="_blank">
                    {{ item.title }}
                  </a>
                </td>
                <td data-th="議題" class="title" v-else>{{ item.title }}</td>
                <td data-th="相關單位" class="td-center">{{ item.depart }} </td>
              </tr>
            </template>
            
          </tbody>
        </table>
      </Tab>

      <Tab title="校發徵件">
        <h2 class="proj-tab-title">校發計畫徵件</h2>

        <div class="filter-div">
            <font-awesome-icon :icon="['fas', 'filter']" />
            執行年度：
            <select class="select" v-model="devProjs.selectYear">
              <option value="all">全部</option>
              <template v-for="(year, index) in devProjs.yearArr" :key="index">
                  <option :value="year">{{ year }}</option>
              </template>
            </select>
            學年度
        </div>

        <div class="devProjs-list" v-if="devProjs.data.length">
          <template v-for="item in devProjs.data" :key="item.id">
            <template v-if="devProjs.selectYear == 'all'">
              <div class="devProjs-list-item">
                  <div class="devProjs-title">
                      <div class="item-year">
                        {{ item.year }}學年度
                        <PurposeBadge :purpose="item.purpose_arr" />
                      </div>
                      <label class="item-label">
                        <template  v-if="item.url">
                        <a v-bind:href="item.url" target="_blank">{{ item.title }}</a>
                        </template>
                        <template  v-else>
                          {{ item.title }}
                        </template>
                      
                      </label>
                      <p class="item-depart">提案單位：{{ item.depart }}</p>
                  </div>

                  <div class="devProjs-content">
                      <p class="form-control-plaintext">主持人：
                        <template v-if="item.host">{{ item.host }}</template>
                        <template v-else> --- </template>
                      </p>
                  
                      <p class="form-control-plaintext">執行期間：
                        <template v-if="item.state=='尚無人申請'"> --- </template>
                          <template v-else>{{ item.start }}~{{ item.end }}</template>
                      </p>
                  </div>

                  <div class="devProjs-state">
                      {{ item.state }}
                  </div>
              </div>
            </template>

            <template v-if="devProjs.selectYear != 'all' && item.year == devProjs.selectYear">
                <div class="devProjs-list-item">
                  <div class="devProjs-title">
                      <div class="item-year">
                        {{ item.year }}學年度
                        <PurposeBadge :purpose="item.purpose_arr" />
                      </div>
                      <label class="item-label">
                        <template  v-if="item.url">
                        <a v-bind:href="item.url" target="_blank">{{ item.title }}</a>
                        </template>
                        <template  v-else>
                          {{ item.title }}
                        </template>
                      
                      </label>
                      <p class="item-depart">提案單位：{{ item.depart }}</p>
                  </div>

                  <div class="devProjs-content">
                      <p class="form-control-plaintext">主持人：
                        <template v-if="item.host">{{ item.host }}</template>
                        <template v-else> --- </template>
                      </p>
                  
                      <p class="form-control-plaintext">執行期間：
                        <template v-if="item.state=='尚無人申請'"> --- </template>
                          <template v-else>{{ item.start }}~{{ item.end }}</template>
                      </p>
                  </div>

                  <div class="devProjs-state">
                      {{ item.state }}
                  </div>
              </div>

            </template>
          </template>
        </div>
           
        <!-- <table class="table table-hover rwd-table">
          <thead>
            <tr>
              <template v-if="devProjs.selectYear == 'all'">
                <th>學年</th>
              </template>
              <th class="th-title">提案單位</th>
              <th class="th-title">議題</th>
              <th>目的</th>
              <th>主持人</th>
              <th>執行期間</th>
              <th>目前執行狀態</th>
            </tr>
          </thead>

          <tbody v-if="devProjs.data.length">
            <template v-for="item in devProjs.data" :key="item.id">
              <tr v-if="devProjs.selectYear == 'all'">
                <td data-th="年度">{{ item.year }}</td>
                <td data-th="提案單位">{{ item.depart }}</td>
                <td data-th="議題" v-if="item.url">
                  <a v-bind:href="item.url" target="_blank">{{ item.title }}</a>
                </td>
                <td data-th="議題" class="title" v-else>{{ item.title }}</td>
                <td data-th="目的" class="td-center"><span class="badge" :class="badgeClass(item.purpose)">{{ item.purpose }}</span></td>
                <td data-th="計畫主持人" class="td-center">
                  <template v-if="item.host">{{ item.host }}</template>
                  <template v-else> --- </template>
                </td>
                <td v-if="item.state=='尚無人申請'" data-th="計畫執行期間" class="td-center"> --- </td>
                <td v-else data-th="計畫執行期間">{{ item.start }}至<br>{{ item.end }}</td>
                <td data-th="目前執行狀態" class="td-center">{{ item.state }}</td>
              </tr>
              
              <tr v-if="devProjs.selectYear != 'all' && item.year == devProjs.selectYear">
                <td data-th="提案單位">{{ item.depart }}</td>
                <td data-th="議題" v-if="item.url">
                  <a v-bind:href="item.url" target="_blank">{{ item.title }}</a>
                </td>
                <td data-th="議題" class="title" v-else>{{ item.title }}</td>
                <td data-th="目的" class="td-center"><span class="badge" :class="badgeClass(item.purpose)">{{ item.purpose }}</span></td>
                <td data-th="計畫主持人" class="td-center">
                  <template v-if="item.host">{{ item.host }}</template>
                  <template v-else> --- </template>
                </td>
                <td v-if="item.state=='尚無人申請'" data-th="計畫執行期間" class="td-center"> --- </td>
                <td v-else data-th="計畫執行期間">{{ item.start }}至<br>{{ item.end }}</td>
                <td data-th="目前執行狀態" class="td-center">{{ item.state }}</td>
              </tr>
            </template>
          </tbody>
        </table> -->

        <div class="table-note">
          <h3>附註：研究目的的類型及說明</h3>
          <ul>
            <li><span class="badge badge-p">政</span>政策型：以適當、週延之方法，研提符合校務發展相關政策，並提出具體措施。</li>
            <li><span class="badge badge-s">建</span>建議型：依校務發展需要，研提可行性之制度面或作業面之改善措施。</li>
            <li><span class="badge badge-i">整</span>整合型：以跨單位整合性議題為主題，研提具體可行之分工與合作機制與執行方式。</li>
            <li><span class="badge badge-e">實</span>實施型：對執行特定工作事項研提具體可行機制、時程規劃、作業規範、操作手冊以及訓練計畫等。</li>
          </ul>
        </div>
      </Tab>
    </TabWrapper>
  </section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import TabWrapper from "@/components/TabWrapper.vue";
import Tab from "@/components/Tab.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/Loader.vue";
import Paginate from "@/components/Paginate.vue";
import PurposeBadge from "@/components/PurposeBadge.vue";

import formatted from "@/mixin/formatted";

export default {
  name: "App",
  components: { Navbar, Header,  Footer, Tab, TabWrapper, Loader, Paginate, PurposeBadge },
  mixins: [formatted],

  data() {
    return {
      title: "校務研究",
      highlightProjs: [],
      allProjs: {
        data: [],
        selectYear: "111",
        yearArr: [],
        searchWords: '',
      },
      devProjs: {
        // data: devProjs,
        data: [],
        selectYear: "all",
        yearArr:[]
      },
      paginate: {
        num: 1,
        size: 9
      }
    };
  },

  methods: {
    pageUpdate(num) {
      this.paginate.num = num;
    },

    badgeClass(purpose) {
      if(purpose == '政') return 'badge-p'
      if(purpose == '建') return 'badge-s'
      if(purpose == '整') return 'badge-i'
      if(purpose == '實') return 'badge-e'
    }
  },

  computed: {
    filterSearch() {
      return this.allProjs.data.filter(searchResult => searchResult.depart.match(this.allProjs.searchWords));
    }
  },

  mounted() {

    //fetch highlight
    fetch("https://oir.nccu.edu.tw/codeigniter/api/results")
      .then((respond) => respond.json())
      .then((data) => {
        setTimeout(() => {
          this.highlightProjs = data;
        }, 300);
          
      })
      .catch((err) => console.log(err.message));

    //fetch all project
    fetch("https://oir.nccu.edu.tw/codeigniter/api/resultlists")
      .then((respond) => respond.json())
      .then((data) => {
        this.allProjs.data = data;
        let  tempYearArr = [];

        for (let index in data) {
          let year = data[index].year;
           tempYearArr.push(parseInt(year));
        }

        this.allProjs.yearArr =  tempYearArr.filter((item, index, arr) => {
	        return arr.indexOf(item) === index;
        })

        this.allProjs.yearArr.sort(function(a, b) {
            return b - a;
        });

        this.allProjs.selectYear = this.allProjs.yearArr[0].toString();

      })
      
      .catch((err) => console.log(err.message));

    //fetch develop proj
    fetch("https://oir.nccu.edu.tw/codeigniter/api/devprojs")
      .then((respond) => respond.json())
      .then((data) => {
        this.devProjs.data = data;
        let tempYearArr = [];

        for (let index in data) {
          let year = data[index].year;
          tempYearArr.push(parseInt(year));
        }

        let yearArr = tempYearArr.filter(function(element, index, arr){
          return arr.indexOf(element) === index;
        });

        this.devProjs.yearArr = yearArr.sort().reverse();
        
      })
      .catch((err) => console.log(err.message));
  },
};
</script>

<style src="@/assets/css/proj.css" scoped></style>
<style src="@/assets/css/rwd-table.css" scoped></style>
<style src="@/assets/css/table.css" scoped></style>
